/* eslint-disable max-len */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import RespondentTypeData from './RespondentTypeData';

const RespondentInformation = ({ respondentInformation }) => {
  const { internalRespondents, externalRespondents } = respondentInformation;

  return (
    <>
      <div className="dashboard-data-container">
        <div>
          <FormattedMessage
            id="dashboard.internal-respondents.title"
            defaultMessage="Internal Respondents (employees)"
            tagName="strong"
          />
        </div>
        <RespondentTypeData respondentData={internalRespondents} />
      </div>

      <div className="dashboard-data-container">
        <div>
          <FormattedMessage
            id="dashboard.external-respondents.title"
            defaultMessage="External Respondents (candidates)"
            tagName="strong"
          />
        </div>
        <RespondentTypeData respondentData={externalRespondents} />
      </div>
    </>
  );
};

RespondentInformation.propTypes = {
  respondentInformation: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default RespondentInformation;
